import React from 'react';
import Image from '@splunk/dashboard-visualizations/Image';
import { ImageContextProvider } from '@splunk/visualization-context/ImageContext';
import ImageRegistry from '@splunk/visualization-context/ImageRegistry';
import MockedProvider from '@splunk/visualization-context/MockedProvider';

const imageRegistry = ImageRegistry.create();
const mockedProvider = new MockedProvider();
imageRegistry.addProvider(mockedProvider);
mockedProvider.upload('https://splunkudftest.s3-us-west-1.amazonaws.com/buttercup.png');

export default () => (
    <ImageContextProvider value={imageRegistry}>
        <Image
            options={{
                src: 'mock://0',
            }}
        />
    </ImageContextProvider>
);
